// src/screens/catalogUpload/components/form/Form.tsx
import { SetStateAction } from 'react'
import { Button } from '../../../../../common/components/button/Button'
import { ImportFileUpload } from '../../../../../common/components/importFileUpload/ImportFileUpload'
import classes from './Form.module.sass'
import { useForm } from './hooks/useForm'
import { CatUploadInterface } from '../../../../../common/types/interfaces'

type Props = {
  edit: boolean
  data?: CatUploadInterface
  setData: React.Dispatch<SetStateAction<CatUploadInterface | undefined>>
  getList: () => void
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  el?: CatUploadInterface
  initialData: CatUploadInterface
  modalActive: boolean
}

export const Form = ({
  edit,
  data,
  setData,
  getList,
  setModalActive,
  el,
  initialData,
  modalActive,
}: Props) => {
  const {
    file,
    setFile,
    formAction,
    jsonData,
    categoriesMeta,
    setCategoriesMeta,
    selectedCategories,
    toggleCategory,
  } = useForm(
    data || initialData,
    setData as React.Dispatch<SetStateAction<CatUploadInterface>>,
    edit,
    getList,
    setModalActive,
    el,
    initialData,
    modalActive,
  )

  return (
    <div className={classes.container}>
      <div className={classes.title}>{edit ? 'Повторный импорт' : 'Загрузка каталога'}</div>

      <ImportFileUpload file={file} setFile={setFile} extensions={['json']} maxCount={1} />

      {jsonData && (
        <div className={classes.preview}>
          <div className={classes.stats}>
            <div className={classes.statItem}>
              <span className={classes.statLabel}>Категорий:</span>
              <span className={classes.statValue}>{jsonData.categories?.length || 0}</span>
            </div>
            <div className={classes.statItem}>
              <span className={classes.statLabel}>Товаров:</span>
              <span className={classes.statValue}>{jsonData.items?.length || 0}</span>
            </div>
          </div>

          <div className={classes.categoriesList}>
            <div className={classes.listTitle}>Категории (выберите для импорта):</div>
            {categoriesMeta.map((cat) => (
              <div key={cat.name} className={classes.categoryItem}>
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(cat.name)}
                  onChange={() => toggleCategory(cat.name)}
                />
                <span className={classes.categoryName}>{cat.name}</span>
                <label className={classes.cleanLabel}>
                  <input
                    type="checkbox"
                    checked={cat.cleanBefore || false}
                    onChange={() => {
                      setCategoriesMeta((prev) =>
                        prev.map((c) =>
                          c.name === cat.name ? { ...c, cleanBefore: !c.cleanBefore } : c,
                        ),
                      )
                    }}
                  />
                  cleanBefore
                </label>
              </div>
            ))}
          </div>
        </div>
      )}

      <Button
        text={edit ? 'Повторить импорт' : 'Импортировать'}
        onClick={formAction}
        disabled={!file || selectedCategories.length === 0}
      />
    </div>
  )
}
